/**
 * Role-based permission utility functions
 */

export const ROLE_TYPES = {
  SUPER_ADMIN: 'Super Admin',
  STORE_MANAGER: 'Store Manager',
  AUTHENTICATOR: 'Authenticator',
  CUSTOMER_SERVICE: 'Customer Service'
};

/**
 * Check if user has permission to perform an action
 */
export const hasPermission = (user, action, resource) => {
  if (!user || !user.role) return false;

  const role = user.role;
  const permissions = getRolePermissions(role);

  // Check if the specific permission exists
  if (permissions[resource] && permissions[resource].includes(action)) {
    return true;
  }

  return false;
};

/**
 * Get all permissions for a role
 */
    export const getRolePermissions = (role) => {
      const permissions = {
        [ROLE_TYPES.SUPER_ADMIN]: {
          // Super Admin can do everything except delete
          users: ['view', 'create', 'edit', 'activate', 'deactivate'],
          roles: ['view', 'create', 'edit', 'activate', 'deactivate'],
          listings: ['view', 'create', 'edit', 'activate', 'deactivate', 'feature'],
          masters: ['view', 'create', 'edit', 'activate', 'deactivate'],
          purchases: ['view', 'edit'],
          deliveries: ['view'],
          stock: ['view', 'edit'],
          reports: ['view'],
          dashboard: ['view']
        },
        [ROLE_TYPES.STORE_MANAGER]: {
          // Store Manager specific permissions
          deliveries: ['view', 'update'],
          stock: ['view', 'update', 'manage'],
          reports: ['view'],
          dashboard: ['view']
        },
        [ROLE_TYPES.AUTHENTICATOR]: {
          // Authenticator specific permissions
          stock: ['view', 'authenticate'],
          dashboard: ['view']
        },
        [ROLE_TYPES.CUSTOMER_SERVICE]: {
          // Customer Service specific permissions
          listings: ['view'],
          dashboard: ['view']
        }
      };

      return permissions[role] || {};
    };

/**
 * Check if user can delete
 */
export const canDelete = (user) => {
  // Super Admin cannot delete (as per requirement)
  return user?.role !== ROLE_TYPES.SUPER_ADMIN;
};

/**
 * Check if user can edit
 */
export const canEdit = (user, resource) => {
  return hasPermission(user, 'edit', resource);
};

/**
 * Check if user can create
 */
export const canCreate = (user, resource) => {
  return hasPermission(user, 'create', resource);
};

/**
 * Check if user is Super Admin
 */
export const isSuperAdmin = (user) => {
  return user?.role === ROLE_TYPES.SUPER_ADMIN;
};

/**
 * Check if user is Store Manager
 */
export const isStoreManager = (user) => {
  return user?.role === ROLE_TYPES.STORE_MANAGER;
};

/**
 * Check if user is Authenticator
 */
export const isAuthenticator = (user) => {
  return user?.role === ROLE_TYPES.AUTHENTICATOR;
};

/**
 * Check if user is Customer Service
 */
export const isCustomerService = (user) => {
  return user?.role === ROLE_TYPES.CUSTOMER_SERVICE;
};


